:host {
  height: 100%;
}

.two-column-grid {
  max-width: 1000px;
}

.timeline {
  width: 100%;
}

.timeline-container {
  position: relative;
  height: 85px;
  margin-left: 40px;
  margin-right: 40px;
  padding: 0 !important;
}

.timeline-bar {
  position: absolute;
  top: 25px;
  height: 2px;
  width: 100%;
  background-color: grey;
}

.complete-bar {
  position: absolute;
  width: 50%; /* overridden by the instance style */
  height: 100%;
  background-color: grey;
  filter: brightness(40%);
}

/** inner progress bar */
.progress-bar {
  position: absolute;
  width: 50%; /* overridden by the instance style */
  height: 100%;
  background-color: var(--ion-color-primary);
}

.overdue-bar {
  position: absolute;
  top: 0;
  height: 100%;
  background-color: var(--color-warning-1, red);
}

.overdue-complete-bar {
  position: absolute;
  top: 0;
  height: 100%;
  background-color: var(--color-warning-1, red);
  filter: brightness(40%);
}

.timeline-state {
  position: absolute;
  top: 25px;
  min-width: 40px;
  color: var(--ion-text-color, white);

  /* center the circle over the point on the bar */
  margin-top: -20px;
  margin-left: -20px;
}

.timeline-state:hover {
  color: var(--ion-color-primary, yellow);
}

.timeline-state label {
  display: block;
  text-transform: capitalize;
  font-size: 10px;
  margin-top: 0px;
  text-align: center;
}

.timeline-state img {
  border-width: 3px;
  border-style: solid;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: antiquewhite;
  cursor: pointer;
}

.timeline-state ion-icon {
  color: grey;
  filter: brightness(40%);
  position: absolute;
  top: -5px;
  left: 24px;
  font-size: 24px;
}

.timeline-complete {
  border-color: grey;
  filter: brightness(40%);
}

.timeline-complete-overdue {
  border-color: var(--color-warning-1, red);
  filter: brightness(40%);
}

.timeline-active {
  border-color: var(--ion-color-primary);
}

.timeline-overdue {
  border-color: var(--color-warning-1, red);
}

.timeline-pending {
  border-color: grey;
  filter: brightness(40%);
}

.timeline-marker {
  width: 40px;
  margin-left: -20px;

  color: var(--ion-text-color, white);
  /*top: 7px;*/
  left: 35%; /* overridden by the instance style */
  position: absolute;
  text-align: center;
}

.timeline-marker label {
  display: block;
  text-transform: capitalize;
  font-size: 10px;
  font-weight: 300;
}

.card-header > ion-card-title {
  width: calc(100% - 110px); /** stops title overlaying the buttons on the end*/
}

.card-header > ion-button {
  float: right;
  margin: 0;
  --padding-end: 3px; /*remove some of the padding off the end so they align with end of header */
}

.comment-header ion-avatar {
  width: 24px;
  height: 24px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 8px;
}

.comment-header ion-button {
  float: inline-end;
  font-size: 0.8em;
  margin: 0;
  --color: var(--ion-card-color, white);
}

.comment-buttons-right {
  float: inline-end;
}

.comment-header ion-icon {
  color: var(--ion-card-color, white);
}

.accept-answer {
  float: inline-end;
  --color: var(--ion-card-color, white);
}

.accept-answer ion-icon {
  --color: var(--ion-card-color, white);
}

.accept-answer ion-label {
  border: '1px solid red';
  color: 'red';
}

.accepted-answer {
  float: inline-end;
  color: var(--color-success-1, green);
}

.accepted-answer ion-icon {
  color: var(--color-success-1, green);
}

.comment-text {
  /*padding-left: 32px;*/
  cursor: pointer;
}

.comment-text:hover {
  background-color: var(--ion-color-step-900);
}

/* Make the text small like whte labels on text inputs once they have content */
.small-super-script {
  font-size: 12px;
  margin-left: 8px;
}

.pseudo-input-editable,
.pseudo-input {
  color: var(--ion-text-color, white);
  --color: var(--ion-text-color) !important;
  border: 1px solid var(--ion-color-step-800) !important;
  border-radius: 5px !important;
  min-height: 42px;
  margin-top: 4px;
}

.pseudo-input {
  background-color: var(--ion-background-color) !important;
}

.pseudo-input > p {
  margin: 8px !important; /* center the text inside the input */
}

.pseudo-input-editable {
  background-color: var(--ion-color-step-900) !important;
  cursor: pointer;
}

.pseudo-input-editable:hover {
  background-color: var(--ion-background-color) !important;
}

.pseudo-input ion-chip {
  background-color: var(--ion-color-step-800) !important;
}

.pseudo-input-button-right {
  margin: 10px;
  float: right;
  font-size: 1.2em;
}

.spaced-icon {
  margin-left: auto;
}

/**
https://ionicframework.com/docs/layout/css-utilities
utility classes that should work from Ionic but do nothing on our project
*/
.ion-display-flex {
  display: flex;
}

.full-height {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.vertical-scroll {
  overflow-y: auto;
  height: 100%;
}

.flex-grow {
  flex-grow: 1;
  overflow-y: auto;
}

@media (min-width: 576px) {
  .cc-padding-horizontal-sm-up {
    padding: 0 16px;
  }
}
/**########################## JUNK ##########################  */
.full {
  display: flex;
  height: 100%;
}

.left {
  min-width: 300px;
}

.rfi-title {
  box-sizing: border-box;
  margin-bottom: 16px;
  padding: 8px;
  font-size: 18px;
  background-color: var(--color-grey-1);
  width: 100%;
}

.rfi-title.closed {
  background-color: var(--ion-color-primary);
  color: var(--color-button-text-1);
}

.tabs {
  display: flex;
}

.tabs label {
  flex: 1;
  cursor: pointer;
}

.tabs label.active {
  cursor: default;
  background-color: var(--color-grey-5);
}

.tab-content.information {
  display: flex;
  flex-direction: column;
}

.information {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.information-edit {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 8px;
  font-size: 18px;
}

.edit-button:hover {
  background-color: var(--color-grey-3);
}

.information-people {
  box-sizing: border-box;
  padding: 8px;
  font-size: 18px;

  color: var(--color-button-text-1);
}

.rfi-number {
  display: flex;
  flex-direction: column;
  padding: 12px;
  font-size: 12px;
}

.due-date,
.activities {
  display: flex;
  flex-direction: column;
  padding: 10px;
  font-size: 12px;
}

.tags {
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  font-size: 12px;
}

.activity-map {
  display: flex;
  flex-wrap: wrap;
}

.activity-map p {
  margin-right: 8px;
  margin-bottom: 8px;
  padding: 8px;
  background-color: var(--color-grey-1);
  border-radius: 15px;
}

.attachments {
  flex-grow: 1;
  padding: 10px;
  font-size: 12px;
}

.right {
  margin-left: 20px;
  height: 100%;
  width: 100%;
}

.right-top {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  min-height: 0;
}

.created-name-date .name {
  margin-right: 10px;
}

.subject {
  margin-left: 10px;
  padding: 18px;
  background-color: var(--color-grey-5);
  color: var(--color-button-text-1);
  border-radius: 15px;
  margin-bottom: 5px;
}

.subject h1 {
  font-size: 18px;
  margin-top: -5px;
}

.subject p {
  font-size: 14px;
  margin-top: -14px;
  margin-bottom: -7px;
}

.comments-container {
  flex-grow: 1;
  overflow-y: auto;
}

.comment {
  display: flex;
  margin-bottom: 20px;
  width: 100%;
}

.comment-right {
  margin-left: 12px;
  padding: 15px;
  border: 1px solid #333;
  border-radius: 5px;
  width: 100%;
}

.comment-heading {
  color: grey;
}

.message-comment {
  margin-left: 10px;
  padding: 5px;
  background-color: var(--color-grey-5);
  color: var(--color-button-text-1);
  border-radius: 35px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.message-comment p {
  font-size: 14px;
  margin: 0;
  margin-left: 10px;
}

.container-bottom {
  display: flex;
  flex-direction: column;
}

.input-container {
  margin-bottom: 15px;
}

input {
  width: 95%;
  padding: 10px;
  border-radius: 20px;
  border-bottom: 1px solid var(--color-foreground-2);
}

.buttons-container {
  display: flex;
  justify-content: space-between;
}

.comment-button,
.action-button {
  max-width: 180px;
  flex-grow: 1;
  cursor: pointer;
  text-align: center;
}

.comment-button {
  background-color: var(--color-button-text-2);
  color: var(--color-button-text-1);
  border: 1px solid var(--color-button-text-1);
  padding: 10px;
  font-weight: bold;
}

.action-button {
  background-color: var(--color-primary-1);
  color: var(--color-button-text-1);
  border: 1px solid var(--color-primary-1);
  padding: 10px;
  font-weight: bold;
  text-transform: uppercase;
  white-space: nowrap;
}

#camera-button ion-icon {
  color: black;
}

.people-summary {
  border: 1px solid var(--color-foreground-2);
}

.people-state {
  text-transform: capitalize;
  padding: 10px;
  font-size: 12px;
}

.people-content {
  display: flex;
}

.people-info {
  font-size: 12px;
  margin-bottom: 10px;
}

.white-space-pre-wrap {
  white-space: pre-wrap;
}

.white-space-pre-line {
  white-space: pre-line;
}

.add-items-popover {
  --width: 220px;
}

/* COPIED from concourse-rfis.css */

.chat-image-row {
  width: 100%; /* not sure why this was necessry, row was only 60% on mobile only*/
}

.chat-image {
  aspect-ratio: 1/1;
  background-position: center center;
  background-size: cover;
  margin: 2px;
  max-width: 50%;
}

.blur {
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 40px;
  background-color: rgba(0, 0, 0, 0.5);
  background-blend-mode: darken;
}

@media (min-width: 768px) {
  .gallery-modal {
    --height: 90%;
    --width: 90%;
    --max-width: 1000px; /* width of images from cloud-convert */
  }
}
